import { render } from "./DatasetList.vue?vue&type=template&id=08c9a0ae&scoped=true"
import script from "./DatasetList.vue?vue&type=script&lang=js"
export * from "./DatasetList.vue?vue&type=script&lang=js"

import "./DatasetList.vue?vue&type=style&index=0&id=08c9a0ae&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-08c9a0ae"

export default script